import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { HttpClient, HttpParams, HttpHeaders } from '@angular/common/http';
import { catchError, map, tap } from 'rxjs/operators';
import { AppSettings } from '../../entities/AppSettings';
import { appSettings } from '../../modules/shared/components/appSettings';
import { IDataEndPoint } from '@framework/interfaces/IEntity';
import { IdentityAuthService } from '@services/identity-auth/identity-auth.service';
import { FileSaverService } from 'ngx-filesaver';

export interface IApiServiceCommand {
  endPoint: IDataEndPoint;
  data?: any;
  context?: any;
  params?: object;
  success?: Function;
  error?: Function;
}
export interface IApiServiceHttpOptions {
  body?: any;
  headers?: HttpHeaders | {
    [header: string]: string | string[];
  };
  params?: HttpParams | {
    [param: string]: string | string[];
  };
  responseType?: 'arraybuffer' | 'blob' | 'json' | 'text';
  reportProgress?: boolean;
  withCredentials?: boolean;
}

@Injectable({
  providedIn: 'root'
})
export class ApiService {
  private heroesUrl = appSettings.apiServiceAddress + '/api/user';
  public appSettings = appSettings;
  public authService: IdentityAuthService
  constructor(
    private http: HttpClient,
    private _FileSaverService: FileSaverService) { }

  exec<T>(serviceCommand: IApiServiceCommand): Observable<any> {
    let observable: Observable<any>
    let method: string = serviceCommand.endPoint.method ? serviceCommand.endPoint.method.toLowerCase() : "get";
    let url: string = {}.toString.call(serviceCommand.endPoint.url) === '[object Function]' ? serviceCommand.endPoint.url(serviceCommand) : serviceCommand.endPoint.url;
    /*
    let options: IApiServiceHttpOptions = {};
    if (serviceCommand.endPoint.params) options.params = new HttpParams({ fromObject: serviceCommand.endPoint.params(serviceCommand) });
    if (method == "post") options.body = serviceCommand.data;
    observable = this.http.request<T>(method, url, {
      body: serviceCommand.data ? serviceCommand.data : null,
      params: serviceCommand.endPoint.params ? new HttpParams({ fromObject: serviceCommand.endPoint.params(serviceCommand) }) : null
    });
    */

    let httpParams: HttpParams;
    if (serviceCommand.endPoint.params) httpParams = new HttpParams({ fromObject: serviceCommand.endPoint.params(serviceCommand) });
    let httpHeaders: HttpHeaders = new HttpHeaders({ "organisation-context": this.authService.currentOrganisationId });
    if (method == "post") {
      
      observable = this.post<T>(url, serviceCommand.data, { params: httpParams, headers: httpHeaders });
    }
    else {
      observable = this.get<T>(url, { params: httpParams, headers: httpHeaders });
    }

    if (serviceCommand.success || serviceCommand.error) {
      observable.subscribe(
        data => { serviceCommand.success(data) },
        error => { serviceCommand.error(error) }
      )
    }
    return observable;
  }
  get<T>(url: string, params?: any): Observable<any> {
    let httpHeaders: HttpHeaders = new HttpHeaders({ "organisation-context": this.authService.currentOrganisationId });
    if (!params)
      params = {};
    params.headers = httpHeaders;
    return this.http.get<T>(appSettings.apiServiceAddress + url, params);
    //.pipe(
    //  tap(heroes => this.log(`fetched list`)),
    //catchError(this.handleError('getList', []))
    //);
  }
  post<T>(url: string, data?: any, params?: any): Observable<any> {
    let httpHeaders: HttpHeaders = new HttpHeaders({ "organisation-context": this.authService.currentOrganisationId });
    if (!params)
      params = {};
    params.headers = httpHeaders;
    return this.http.post<T>(appSettings.apiServiceAddress + url, data, params);
    //.pipe(
    //  tap(heroes => this.log(`created item`)),
    //catchError(this.handleError('create', []))
    //);
  }

  getItem(id: string): Observable<any> {
    const url = `${this.heroesUrl}/${id}`;
    return this.http.get<any>(url);
    //.pipe(
    //  tap(_ => this.log(`fetched item id=${id}`)),
    //  catchError(this.handleError<any>(`fetched item id=${id}`))
    //);
  }

  private log(message: string) {
    //this.messageService.add('ApiService: ' + message);
  }

  /**
 * Handle Http operation that failed.
 * Let the app continue.
 * @param operation - name of the operation that failed
 * @param result - optional value to return as the observable result
 */
  private handleError<T>(operation = 'operation', result?: T) {
    return (error: any): Observable<T> => {

      // TODO: send the error to remote logging infrastructure
      console.error(error); // log to console instead

      // TODO: better job of transforming error for user consumption
      this.log(`${operation} failed: ${error.message}`);

      // Let the app keep running by returning an empty result.
      return of(result as T);
    };
  }

  private getFile(url: string) {
    let headers = new HttpHeaders().append("Authorization", "Bearer " +
      this.authService.access_token)
    return this.http.get( url, { responseType: 'arraybuffer', headers: headers });
  }

  public saveFile(blob, fileName) {
    if (fileName)
      this._FileSaverService.save(blob, fileName);
    else this._FileSaverService.save(blob);
  }

  public downloadFile(endPoint: string) {
    let headers = new HttpHeaders().append("Authorization", "Bearer " +
      this.authService.access_token)
    return this.http.get(endPoint, { responseType: 'arraybuffer', headers: headers });
  }
}


